function Terms() {
  return (
    <div className="privacy">
        <div className="privacy-container">
            <div className="page-header">
                <h1>利用規約 - Terms of Service</h1>
                <p>最終更新日: 2026年01月21日</p>
            </div>
            <div className="privacy-content">
                <section>
                    <p>
                        この利用規約（以下「本規約」とします）は、OratyLabo(旧ゆーたの開発ラボ)（以下「当グループ」とします）がWebサイト及びDiscord上で提供するサービス（以下「本サービス」とします）の利用条件を定めるものです。
                        ユーザーの皆さま（以下「ユーザー」とします）には、本規約に従って本サービスをご利用いただきます。
                    </p>
                </section>
                <section>
                    <h2>第1条 (適用)</h2>
                    <p>
                        本規約は、ユーザーと当グループとの間の本サービスの利用に関わる一切の関係に適用されるものとします。
                        当グループが本規約以外に別途ユーザー向けにサービスに関する利用条件等を提示した場合は、ユーザーは本規約のほか、当該利用条件に従って本サービスを利用するものとします。
                    </p>
                </section>
                <section>
                    <h2>第2条 (利用)</h2>
                    <ol>
                        <li>本サービスにおいては、Discordサーバー管理者がBotを導入または、ユーザーがBotを使用・導入されているサーバーに属することによって、本規約が適用されるものとします。</li>
                        <li>当グループは、ユーザーに以下の事由があると判断した場合、利用を拒否する事があり、その理由については一切の開示義務を負わないものとします。</li>
                    </ol>
                    <ul>
                        <li>Discord の利用規約に違反しているユーザー</li>
                        <li>他サーバーでスパムなどの迷惑行為をしているユーザー</li>
                        <li>その他、当グループが利用することが相当でないと判断した場合</li>
                    </ul>
                </section>
                <section>
                    <h2>第3条 (禁止事項)</h2>
                    <p>ユーザーは、本サービスの利用にあたり、以下の行為をしないものとします。</p>
                    <ol>
                        <li>法令または公序良俗に違反する行為</li>
                        <li>犯罪行為に関連する行為</li>
                        <li>本サービスの内容等、本サービスに含まれる著作権、商標権ほか知的財産権を侵害する行為</li>
                        <li>当グループのサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
                        <li>当グループのサービスの運営を妨害するおそれのある行為</li>
                        <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
                        <li>他のユーザーに成りすます行為</li>
                        <li> 本サービスの他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為</li>
                        <li>当グループのサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
                        <li>当グループが提供するBotのコンテンツをコピーまたは、全部あるいは一部を無断で利用する行為</li>
                        <li>その他、当グループが不適切と判断する行為</li>
                    </ol>
                </section>
                <section>
                    <h2>第4条 (本サービスの提供の停止等)</h2>
                    <ol>
                        <li>当グループは、以下のいずれかの事由があると判断した場合、本サービスの全部または一部の提供を停止または中断することができるものとします。</li>
                    
                        <ol>
                            <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う上でやむを得ないとき</li>
                            <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
                            <li>電気通信事業者の都合により本サービス用通信回線の使用が不能なとき</li>
                            <li>オーナーの資金が尽きたまたは心が折れた場合</li>
                            <li>その他、当グループが本サービスの提供が困難と判断した場合</li>
                        </ol>

                        <li>当グループは、前項の規定により本サービスの提供を一時的に停止するときは、あらかじめその旨をユーザーに通知するものとします。<br/>
                        ただし、本サービスの利用に支障が生じないと当グループが判断する短時間の停止または緊急やむを得ない場合は、この限りではありません。
                        </li>
                        <li>当グループは、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。</li>
                    </ol>
                </section>
                <section>
                    <h2>第5条 (処罰等)</h2>
                    <ol>
                        <li>当グループは、第3条 (禁止事項) などに基づきユーザーに対して予告なしに処罰することがあります。</li>
                        <li>処罰を受けたユーザーは公式サーバーのお問い合わせチャンネルを使用して1度のみ異議申し立てすることができるものとします。</li>
                        <li>異議申し立てが行われた場合運営内で審議を行い、
                            <ol>
                                <li>異議申し立てが受理された場合、処罰の取り消しまたは減免を行います。</li>
                                <li>異議申し立てが棄却された場合、処罰を受けたユーザーは棄却されたことをお知らせいたします。</li>
                            </ol>
                        </li>
                    </ol>
                </section>
                <section>
                    <h2>第6条 (免責事項)</h2>
                    <ol>
                        <li>当グループの債務不履行責任は、当グループの故意または重過失によらない場合には免責されるものとします。</li>
                        <li>当グループは、ユーザーが支障なく本サービスを利用できるように、本サービスを運営するよう努めるものとします。</li>
                        <li>当グループは、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。</li>
                    </ol>
                </section>
                <section>
                    <h2>第7条 (サービス内容の変更等)</h2>
                    <p>当グループは、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。</p>
                </section>
                <section>
                    <h2>第8条 (規約の変更)</h2>
                    <p>
                        当グループは、ユーザーの承諾を得ることなく、本規約を変更することがあります。
                        この場合には、規約変更に先たち当グループ公式サーバーへの掲載等によりユーザーにお知らせいたします。
                        規約変更後の本サービスの提供条件は変更後の利用規約によるものとします。
                    </p>
                </section>
                <section>
                    <h2>第9条 (個人情報の取扱い)</h2>
                    <p>当グループは、本サービスの利用によって取得する個人情報については、当グループ「プライバシーポリシー」に従い、適切に取り扱うものとします。</p>
                </section>
                <section>
                    <h2>第10条 (通知または連絡)</h2>
                    <p>ユーザーと当グループとの間の通知または連絡は、当グループの定める方法によって行うものとします。</p>
                </section>
                <section>
                    <h2>第11条 (準拠法)</h2>
                    <p>本規約の解釈にあたっては、日本法を準拠法とします。</p>
                </section>
                <p>以上</p>
            </div>
            <div className="privacy-footer">
                <p>制定日: 2023年04月04日</p>
                <p>改定日: 2026年01月21日</p>
                <p>OratyLabo (旧:ゆーたの開発ラボ)</p>
          </div>
        </div>
    </div>
  )
}

export default Terms